// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4fb10229","453":"cd2163fa","455":"eb2ee091","977":"99163f6a"}[chunkId] + ".chunk.js";
};